<template>
    <div class="editDialog">
        <el-dialog
            :title="isEdit ? '修改' : '入库'"
            :visible.sync="dialogShow"
            :before-close="handleClose"
            width="700px"
            :close-on-click-modal="false"
        >
            <div class="content">
                <el-form
                    :inline="true"
                    :model="formEdit"
                    label-width="80px"
                    :rules="rules"
                    :ref="refName"
                >
                    <div class="el-form-area">
                        <el-form-item label="设备编码" prop="id">
                            <el-input
                                v-model="formEdit.id"
                                placeholder="请输入设备编码"
                                :disabled="isEdit"
                                clearable
                                maxlength="50"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="设备密码" prop="password">
                            <el-input
                                v-model="formEdit.password"
                                placeholder="请输入设备密码"
                                :disabled="isEdit"
                                clearable
                                maxlength="50"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="设备名称" prop="name">
                            <el-input
                                v-model="formEdit.name"
                                placeholder="请输入设备名称"
                                clearable
                                maxlength="50"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="客户" prop="companyId">
                            <el-select
                                v-model="formEdit.companyId"
                                placeholder="请选择客户"
                                clearable
                            >
                                <el-option
                                    v-for="(item, index) in companyList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                    clearable
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="通讯模式" prop="mode">
                            <el-select
                                v-model="formEdit.mode"
                                placeholder="4G/WIFI"
                                clearable
                            >
                                <el-option
                                    v-for="(item, index) in communicationMode"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                    clearable
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="固件版本" prop="version">
                            <el-select
                                v-model="formEdit.version"
                                placeholder="选择固件版本"
                                :disabled="isEdit"
                                clearable
                            >
                                <el-option
                                    v-for="(item, index) in versionSet"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                    clearable
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="ICCID" prop="iccid">
                            <el-input
                                v-model="formEdit.iccid"
                                placeholder="ICCID"
                                clearable
                                maxlength="50"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="卡提供方" prop="supply">
                            <el-input
                                v-model="formEdit.supply"
                                placeholder="supply"
                                clearable
                                maxlength="50"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="卡到期" prop="expiration">
                            <el-date-picker
                                v-model="formEdit.expiration"  
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                clearable
                                style="width: 100%"
                                type="datetime">
                                </el-date-picker>
                        </el-form-item>
                        <el-form-item label="服务周期" prop="date">
                            <el-date-picker
                                v-model="formEdit.date"
                                type="daterange"
                                range-separator="-"
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item class="uploadArea" label="现场照片" prop="imageSet">
                            <UploadImg
                                v-if="dialogShow"
                                ref="imageSet"
                                :limit="9"
                                :size="5"
                                :files="formEdit.imageSet"
                            />
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import UploadImg from '@/components/Upload/UploadImg';
import editDialogMixin from '@/mixins/editDialogMixin';
export default {
    props: {
        versionSet: {
            type: Array,
            default() {
                return []
            }
        },
        companyList: {
            type: Array,
            default() {
                return []
            }
        },
        communicationMode:{
            type: Array,
            default() {
                return[{
                    label: '4G', value:'4G'
                },{
                    label: 'WIFI', value:'WIFI'
                }]
            }
        }
    },
    components: {
        UploadImg
    },
    mixins: [editDialogMixin],
    data() {
        const validateCode = (rule, val, callback) => {
            let reg = /^[a-zA-Z0-9]{1,50}$/;
            if (!reg.test(val)) {
                callback(new Error('请输入1-50位大、小写英文字母或数字'));
            } else {
                callback();
            }
        };
        return {
            formReset: {
                id: null,
                name: '',
                date: [],
                companyId: '',
                serviceStart: '',
                serviceEnd: '',
                imageSet: [],
                mode: '',
                iccid: '',
                supply:'',
                expiration: '',
                version: ''
            },
            rules: {
                id: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: validateCode
                    }
                ],
                name: [
                    {
                        required: true,
                        message: '设备名称不能为空',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        handleSubmit() {
            this.$refs[this.refName].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.$http
                            .post(
                                this.isEdit ? '/device/modify/v1' : '/device/registry/v1',
                                {
                                    ...this.formEdit,
                                    imageSet: this.$refs.imageSet.getImgList(),
                                    serviceStart: this.formEdit.date?this.formEdit.date[0]:'',
                                    serviceEnd: this.formEdit.date?this.formEdit.date[1]:''
                                },
                                '提交中……',
                                '新建成功'
                            )
                            .then(res => {
                                this.$emit('updateData');
                                this.handleClose();
                            });
                    });
                }
            });
        }
    }
};
</script>